'use strict';

angular.module('youth', ['msUtility', 'msCore', 'msProfile', 'msActivityServices', 'msTracker', 'msCommunity', 'msLegacyActivities', 'ngAnimate', 'smoothScroll', 'slickCarousel', 'ngStorage', 'ngAria']).constant('context', 'youth').run(['NotifyingSvc', '$state', '$rootScope', '$timeout', '$document', 'activitySvc', 'ModalService', function (NotifyingSvc, $state, $rootScope, $timeout, $document, activitySvc, ModalService) {
  $rootScope.$state = $state;

  NotifyingSvc.subscribe(NotifyingSvc.EVENTS.PAGE_TITLE, function (event, data) {
    $timeout(function () {
      $rootScope.$state.current.data = {
        pageTitle: data.pageTitle + ' | myStrength'
      };
    });
  });

  NotifyingSvc.subscribe(NotifyingSvc.EVENTS.OPEN_MODAL, function (event, data) {
    ModalService.showModal({
      appendElement: angular.element($document[0].getElementById('modalTarget')),
      templateUrl: data.templateUrl || 'vnext/templates/generic-modal.html',
      controller: data.controller || 'GenericModalCtrl',
      controllerAs: data.controllerAs || '$ctrl',
      inputs: data.inputs,
      scope: data.scope,
      locationChangeSuccess: false
    }).then(function (modal) {
      modal.close.then(function (result) {
        if (angular.isFunction(data.closeCallback)) {
          data.closeCallback(result);
        }
      });
    });
  });

  activitySvc.clearYouthActivityCacheListener();
}]);